import apiClient from "../authentication/utils/core/axios";

const ReportAPI = {
  async createReport(payload) {
    const response = await apiClient.post("/report/", payload);
    if (response.status !== 201) throw new Error("Failed to create report");
    return response.data;
  },
};

export default ReportAPI;
